<template>
  <div class="main">

    <div class="communicate2">

      <div class="left" :style="[styleObj]">
        <div class="communicate1">
          <div :class="{ active: promoterBy == (index - 1), common: promoterBy != (index - 1) }"
            v-for="(item, index) in chooseTypes" :key="index" @click="switchMsg(index)">
            {{ item }}
          </div>
        </div>
        <div class="search">
          <el-autocomplete v-model="resNames" class="inline-input" :fetch-suggestions="querySearch" placeholder="请选择职位"
            value-key="positionTitle" @select="getChatMsgList"></el-autocomplete>
          <el-button type="primary" @click="chongzhi">重置</el-button>
        </div>
        <div class="left1">
          <span :class="{ active1: readStatus == 0, active2: readStatus != 0 }" @click="switchMsgStatus(0)">全部</span>
          <span :class="{ active1: readStatus == 1, active2: readStatus != 1 }" @click="switchMsgStatus(1)">未读</span>
        </div>
        <div class="systemList" :style="[styleObj2]">
          <div class="system" @click="getChatMsg(item)" v-for="(item, index) in chatMsgList" :key="index"
            :class="{ 'systemActive': item.chatId == chatId }">
            <div class="systemBox">
              <div class="systemLeft">
                <img :src="item.memberUserId == '0'? 'https://rerca.hntstg.com/imgFile/1813929371900051456_9cb4f93ad055e0ffc6536b8ea7f4eac0.png' : item.memberUserImage" class="header" />
                <div class="subscript" v-if="item.unreadCount > 0">{{ item.unreadCount <= 99 ? item.unreadCount : '99+'
                    }} </div>
                </div>
                <div class="systemRight">
                  <!-- <div> -->
                  <div class="chat1">
                    <div class="chat1Name">
                      <div class="name">{{ item.memberUserId == '0' ? '客服' : item.memberUserName ? item.memberUserName
                        :
                        '' }}</div>
                     <!-- <div class="zhiwei">{{ item.resName }}</div>-->
                    </div>
                    <div class="chat2">
                      <span v-if="item.messageType == '2'">【图片】</span>
                      <span v-if="item.messageType != '2'" v-html="item.latestMessage"></span>
                    </div>
                  </div>
                  <div class="chat3">
                    {{ item.latestMessageTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="rightTop" v-if="memberInfo.memberUserId != '0'">
            <div class="rightTop1">
              <div>
                <div class="rightTop1Item1">
                  <span class="rightTop1Item1Span">{{ memberInfo.memberUserName }}</span>
                  <!-- <img src="" alt="" /> -->
                </div>
                <div class="rightTop1Item2" v-if="(Object.keys(memberInfo).length !== 0 && memberInfo != null)">
                  <span v-if="memberInfo.memberUserAge">{{ memberInfo.memberUserAge }}岁</span><span
                    v-if="memberInfo.memberUserAge">|</span>
                  <span v-if="memberInfo.memberUserJobYear">{{ memberInfo.memberUserJobYear }}年</span><span
                    v-if="memberInfo.memberUserJobYear">|</span>
                  <span>{{ memberInfo.memberUserEducated }}</span>
                </div>
              </div>
              <div class="rightTop1Item3" v-if="chatId">
                <div @click="seejianli">查看简历</div>
                <div @click="seegangwei">查看岗位</div>
                <!-- <div>交换微信号</div> -->
              </div>
            </div>
            <div class="rightTop2">
              <div class="rightTop2Item1" v-if="projectExperienceList">
                <el-timeline class="Rtimeline " :reverse="true" v-if="userResume">
                  <el-timeline-item v-for="(item, index) in projectExperienceList" :key="index">
                    {{ item.beginTime }} ~ {{ item.endTime }}<span style="padding: 0 5px;"></span>{{ item.projectName }}
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div class="rightTop2Item2" v-if="userResume">
                <div class="itemitems">
                  <div class="itemitemText">沟通岗位：</div>{{ userResume.positionOneName }}
                </div>
                <div class="itemitems">
                  <div class="itemitemText">期望：
                  </div>{{ userResume.city }}·{{
                    userResume.positionOneName }}/{{
                    userResume.positionTypeName }}
                  <span style="color:#F1B901;margin-left: 10px;">
                    {{ userResume.expectedSalary }}元/月</span>
                </div>
              </div>
            </div>
          </div>
          <div class="rightTop" v-if="memberInfo.memberUserId == '0'">
            <span class="rightTop1Item1Span">客服</span>
          </div>
          <div class="rightDown" :style="styleObj4">
            <div class="content scroll-bar-overlay" id="content" :style="styleObj4" ref="chatcontents">
              <div v-if="chatMessageList2.length > 0">
                <div class="s" v-for="(item, index) in chatMessageList2" :key="index">
                  <div class="chatTime" v-if="item.showTime == 0">{{ item.createTime }}</div>
                  <div class="chatOtherSide" v-if="item.targetUserId == memberInfo.companyUserId">
                    <img class="touxiang" :src="memberInfo.memberUserImage" />
                    <div v-if="item.messageType == 1" v-html="item.messageText" class="chatOtherText"></div>
                    <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
                  </div>
                  <div class="chatOwn" v-if="item.targetUserId != memberInfo.companyUserId">
                    <div v-if="item.messageType == 1" v-html="item.messageText" class="chatText"></div>
                    <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
                    <img class="touxiang" :src="memberInfo.companyUserImage" />
                  </div>
                </div>
              </div>
              <div class="chatContent" v-for="(item, index) in chatMessageList1" :key="index">
                <div class="chatTime" v-if="item.showTime == 0">{{ item.createTime }}</div>
                <div class="chatOtherSide" v-if="item.targetUserId == memberInfo.companyUserId">
                  <img class="touxiang" :src="memberInfo.memberUserImage" />
                  <div v-if="item.messageType == 1" v-html="item.messageText" class="chatOtherText"></div>
                  <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
                </div>
                <div class="chatOwn" v-if="item.targetUserId != memberInfo.companyUserId">
                  <div v-if="item.messageType == 1" v-html="item.messageText" class="chatText"></div>
                  <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
                  <img class="touxiang" :src="memberInfo.companyUserImage" />
                </div>
              </div>
              <div style="height: 100px;" ref="footer"></div>
            </div>
            <div class="msgBox">
              <!-- <div>
              <div>
                <div>
                  <img src="" alt="">
                  <img src="" alt="">
                  <img src="" alt="">
                  <img src="" alt="">
                </div>
                |
                <div>
                  <span>求简历</span>
                  <span>换电话</span>
                  <span>换微信</span>
                  <span>约面试</span>
                </div>
              </div>
              <div>
                不合适
              </div>
            </div> -->
              <div class="msgInput" placeholder="请输入内容" contenteditable></div>
              <div class="sendMsg" @click="sendMsg">
                <span>发送</span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <el-dialog title="查看简历" :visible.sync="show">
        <!-- <el-form :model="resumeForm" class="form1" ref="resumeForm" label-width="70px">
        <el-form-item label="名字">
          <el-input v-model="resumeForm.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="resumeForm.phone" :disabled="true" />
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="resumeForm.sex" :disabled="true" />
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="resumeForm.age" :disabled="true" />
        </el-form-item>
        <el-form-item label="学历">
          <el-input v-model="resumeForm.educated" :disabled="true" />
        </el-form-item>
        <el-form-item label="工作年限">
          <el-input v-model="resumeForm.jobYear" :disabled="true" />
        </el-form-item>
        <el-form-item label="期望薪资">
          <el-input v-model="resumeForm.expectedSalary" :disabled="true" />
        </el-form-item>
        <el-form-item label="毕业院校">
          <el-input v-model="resumeForm.college" :disabled="true" />
        </el-form-item>
        <el-form-item label="应聘岗位">
          <el-input v-model="resumeForm.resName" :disabled="true" />
        </el-form-item>
        <el-form-item label="工作经验">
          <div style="    background-color: #F5F7FA;
    border-color: #E4E7ED;padding: 8px;line-height: 1.5;    color: #C0C4CC;">{{ resumeForm.newExperience }}</div>
        </el-form-item>
      </el-form> -->
        <el-descriptions title="基本信息" :column="3" border>
          <el-descriptions-item label="姓名">{{ resumeForm.name }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ resumeForm.sex }}</el-descriptions-item>
          <el-descriptions-item label="照片">
            <image-preview :src="resumeForm.photo" :width="67" :height="67" />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="" :column="2" border>
          <el-descriptions-item label="出生日期">{{ resumeForm.birthDate }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ resumeForm.phone }}</el-descriptions-item>
          <el-descriptions-item label="邮箱">{{ resumeForm.email }}</el-descriptions-item>

          <el-descriptions-item label="身份">{{ resumeForm.identity }}</el-descriptions-item>

          <el-descriptions-item label="毕业学校">{{ resumeForm.college }}</el-descriptions-item>
          <el-descriptions-item label="学历">{{ resumeForm.educated }}</el-descriptions-item>

          <el-descriptions-item label="入学时间">{{ resumeForm.collegeDate }}</el-descriptions-item>
          <el-descriptions-item label="工作经验">{{ resumeForm.jobYear }}年</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="简述信息">{{ resumeForm.briefly
            }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="求职意向" :column="1" border>
          <el-descriptions-item label-class-name="experience_class" label="期望区域">{{ resumeForm.province }}-{{
            resumeForm.city }}-{{ resumeForm.area }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="期望行业">{{ resumeForm.positionOneName }}—{{
            resumeForm.positionTypeName }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="期望薪资">{{ resumeForm.expectedSalary
            }}</el-descriptions-item>

          <el-descriptions-item label-class-name="experience_class" label="工作时间">{{ resumeForm.workWeekend
            }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="工作时段">{{ resumeForm.workTime
            }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="每周工作">{{ resumeForm.everyWeek
            }}</el-descriptions-item>
        </el-descriptions>
        <!-- 工作经验 -->
        <el-descriptions title="项目经验" v-if="resumeForm.memberProjectExperienceList" :column="1" border />

        <el-descriptions v-for="(item, index) in resumeForm.memberProjectExperienceList" :key="index" title=""
          :column="1" border>
          <el-descriptions-item label-class-name="experience_class" label="项目名">{{ item.projectName
            }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="时间">{{ item.beginTime }}——{{ item.endTime
            }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="责任描述">{{ item.dutyInfo
            }}</el-descriptions-item>
        </el-descriptions>

        <!-- 技能证书 -->
        <el-descriptions title="技能证书" v-if="resumeForm.resumeCertificateList" :column="1" border />

        <el-descriptions v-for="(item, index) in resumeForm.resumeCertificateList" :key="index" title="" :column="1"
          border>
          <!-- <el-descriptions-item label-class-name="experience_class" label="技能">{{ item.skillType
            }}</el-descriptions-item> -->
          <el-descriptions-item label-class-name="experience_class" label="证书">{{ item.certificateType
            }}</el-descriptions-item>
          <el-descriptions-item label-class-name="experience_class" label="证书图片">
            <image-preview v-for="(ite, i) in item.certificateImg" :key="i" :src="ite" :width="67" :height="67" />
          </el-descriptions-item>
        </el-descriptions>

      </el-dialog>
      <el-dialog title="查看岗位" :visible.sync="showGangwei"   @close="cancel" width="700px" append-to-body>
        <div v-if="positionApplicationList.length === 0" class="no-data-tip">
          暂未报名岗位
        </div>
        <div v-for="(item, index) in positionApplicationList" :key="index" class="position-item">
              <h3>{{ item.positionTitle }}</h3>
              <p>类型: {{ item.typeName }}</p>
              <p>职位偏好: {{ item.positionWorkTypeName }}</p>
              <p>工作地址: {{ item.provinceName }}/{{ item.cityName }}/{{ item.areaName }} {{ item.workAddress || '-' }}</p>
              <p>薪资范围: {{ item.salaryBegin ? item.salaryBegin : '-' }} - {{ item.salaryEnd ? item.salaryEnd : '-' }} {{ item.salaryUnit || '元' }}</p>
              <p>结算方式: {{ item.settlementMethod || '未指定' }}</p>
              <p>招聘人数: {{ item.recruitNumber || '未指定' }}</p>
              <p>职位描述: {{ item.positionDescribe || '暂无描述' }}</p>
              <p>职位要求: {{ item.personnelRequire || '暂无要求' }}</p>
              <p>工作周期: {{ item.workCycle === '0' ? '兼职' : '全职' }}</p>
              <p>每周工作天数: {{ item.weekWorkDay || '未指定' }}</p>
              <p>工作时间: {{ item.workTime || '未指定' }}</p>
              <p>工作时段: {{ item.workPeriod || '未指定' }}</p>
          </div>
      </el-dialog>
      <!--<el-dialog title="查看岗位" :visible="showGangwei" @close="cancel" width="700px" append-to-body>

        <el-descriptions title="" :column="1" border>
          <el-descriptions-item label-class-name="my-label" label="职位名称">{{ form.positionTitle }}</el-descriptions-item>
          &lt;!&ndash; <el-descriptions-item label="发布人">{{ form.companyUserName }}</el-descriptions-item> &ndash;&gt;
          <el-descriptions-item label="联系电话">{{ form.contactPhone }}</el-descriptions-item>
          &lt;!&ndash; <el-descriptions-item label="邮箱">{{form.email}}</el-descriptions-item> &ndash;&gt;
          &lt;!&ndash; <el-descriptions-item label="所属企业">{{ form.companyName }}</el-descriptions-item> &ndash;&gt;

          <el-descriptions-item label="职位类型">{{ form.positionTypeName }} /
            {{ form.positionTypeSecondaryName }}</el-descriptions-item>
          <el-descriptions-item label="职位偏好">{{ form.positionWorkTypeName }}</el-descriptions-item>
          <el-descriptions-item label="工作地址">{{ form.provinceName }}/{{ form.cityName }}/{{ form.areaName }}
            {{ form.workAddress }}</el-descriptions-item>

          <el-descriptions-item label="职位标签">
            <el-tag v-for="item in tags" :key="item" effect="plain" style="margin-left: 10px">{{ item }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="职位描述">
            <div style="word-break: break-all;white-space: pre-line;" v-html="form.positionDescribe"></div>
          </el-descriptions-item>
          <el-descriptions-item label="职位要求">
            <div style="word-break: break-all;white-space: pre-line;" v-html="form.personnelRequire"></div>
          </el-descriptions-item>
          <el-descriptions-item label="招聘人数">{{ form.recruitNumber }}</el-descriptions-item>

          <el-descriptions-item label="薪资范围"> {{
            (form.salaryBegin ? form.salaryBegin : '') + (form.salaryEnd ? '-' + form.salaryEnd : '') + form.salaryUnit
            }}</el-descriptions-item>
          <el-descriptions-item label="结算方式">{{ form.settlementMethod }}</el-descriptions-item>

          <el-descriptions-item label="福利提成">
            <div style="word-break: break-all;white-space: pre-line;" v-html="form.welfareCommission"></div>
          </el-descriptions-item>
          <el-descriptions-item label="工作周期">{{ form.workCycle == '0' ? '兼职' : '全职' }}</el-descriptions-item>
          <el-descriptions-item label="每周工作天数">{{ form.weekWorkDay }}</el-descriptions-item>
          <el-descriptions-item label="工作时间">{{ form.workTime }}</el-descriptions-item>
          <el-descriptions-item label="工作时段">{{ form.workPeriod }}</el-descriptions-item>
        </el-descriptions>
      </el-dialog>-->
    </div>
</template>
<script>
export default {
  data() {
    return {
      chooseTypes: ['全部', '我发起的', '中意我的'],
      pageNum: 1,
      active: "0",
      chatMessageList1: [],
      chatMessageList2: [],
      showShare: false,
      chatList: [1, 2, 3, 4],
      readStatus: 0,
      resId: '',
      positionList: [],
      promoterBy: '-1',
      chatMsgList: [],
      socket1: null,
      socket2: null,
      messageText: '',
      chatId: '',
      memberUserId: '',
      memberInfo: {},
      previousScroll: 0,
      isLastPage: false,
      projectExperienceList: [],
      userResume: null,
      resName: '',
      state1: '',
      resNames: '',
      chatPage: 0,
      styleObj: {
        height: 0
      },
      styleObj2: {
        height: 0
      },
      styleObj3: {
        height: 0
      },
      styleObj4: {
        height: 0
      },
      chatItem: '',
      show: false,
      resumeForm: '',
      timer: null,
      showGangwei:false,
      positionApplicationList:[],
      form: {
        positionTypeId: null,
        positionTypeIdSecondary: null,
        positionType: [],
        positionTitle: null,
        positionWorkTypeId: '',
        workCycle: null,
        weekWorkDay: null,
        workTime: '',
        workPeriod: [],
        provinceName: null,
        cityName: null,
        areaName: null,
        workAddress: null,
        longitude: null,
        latitude: null,
        salaryBegin: null,
        salaryEnd: null,
        salaryUnit: null,
        contactPhone: null,
        positionDescribe: '',
        recruitNumber: null,
        settlementMethod: '',
        personnelRequire: '',
        welfareCommission: '',
        positionTag: [],
        region: [],
      },
      tags:[]
    };
  },
  mounted() {

    this.chatId = this.$cookie.get('chatId') || ''
    this.getCompanyPositionList()
    this.getChatMsgList()
    if ("WebSocket" in window) {
      let that = this
      console.log("123123213")
      that.socket1 = new WebSocket(this.$websocket + '/websocketServer/0/' + that.$cookie.get('companyUserId'))
      that.socket1.addEventListener('open', function () {
         console.log('1连接上了')
      })
      that.socket1.addEventListener('message', res => {
         console.log(res)
        let res1 = JSON.parse(res.data)
        console.log(res1, 1111)
        if (res1.chat) {
          let arr = that.chatMsgList
          let small = {}
          let index = 0
          arr.forEach((v, k) => {
            if (v.chatId == res1.chat.chatId) {
              v.unreadCount += 1
              v.latestMessage = res1.chat.latestMessage
              v.latestMessageTime = res1.chat.latestMessageTime
              small = v
              index = k
            }
          })
          arr.splice(index, 1)
          arr.unshift(small)
          that.chatMsgList = arr
        }
      })

      // setTimeout(() => {
      this.socketConnect()

      // }, 500)
    }

    if (this.$cookie.get('chatId') && this.$cookie.get('JresumeId')) {
      this.createChatRoom()
    } else if (this.$cookie.get('JresumeId')) {
      this.createChatRoom()
    }

    // document.getElementById('content').scrollTop=150
    document.getElementById('content').addEventListener('scroll', res => {
      const currentScroll = res.target.scrollTop;
      if (currentScroll > this.previousScroll) {
        // console.log('向下滚动');
        // console.log(currentScroll)
      } else {
        // console.log('向上滚动');
        if (currentScroll < 1) {
          if (this.isLastPage) {
            this.$message('没有更多了')
          } else {
            this.pageNum += 1
            this.getChatMessageList2()
          }
        }
      }
      this.previousScroll = currentScroll;
    });
    window.addEventListener('keydown', this.handleKeyDown);

    window.onresize = () => {
      this.$nextTick(() => {
        // let appH = document.documentElement.clientHeight
        let appH = document.body.offsetHeight
          let navbarH = document.getElementsByClassName('navbar')[0].clientHeight
          let rightTopH = document.getElementsByClassName('rightTop')[0].clientHeight
          let msgBoxH = document.getElementsByClassName('msgBox')[0].clientHeight
          this.chatPage = appH - 80 - 10
          this.styleObj = {
            height: (appH - navbarH - 20) + 'px'
          }
          this.styleObj2 = {
            height: (appH - 100 - 90 - 10) + 'px'
          }
          this.styleObj3 = {
            height: (appH - 100 - 200 - 10) + 'px'
          }
          this.styleObj4 = {
            height: (appH - navbarH - rightTopH - msgBoxH -30) + 'px'
          }
      })
    }

  },
  beforeDestroy() {
    // 在组件销毁之前解绑事件监听器
    window.removeEventListener('keydown', this.handleKeyDown);

  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    createChatRoom() {
      this.$post('/api/company/chat/createChatRoom', { resumeId: this.$cookie.get('JresumeId') }).then(res => {
        if (res.code == 200) {
          this.$cookie.set('JresumeId', '')
          console.log('创建成功');
          this.chatId = res.data.chatId
          this.getChatMsgList()
          this.getChatMsgs()
        }
      })
    },

    socketConnect() {
      let that = this
      console.log("23333333333")
      that.socket2 = new WebSocket(that.$websocket + '/websocketServer/0/' + that.$cookie.get('companyUserId'))
      that.socket2.addEventListener('message', res => {
         console.log(res)
        let res1 = JSON.parse(res.data)
        console.log(res1, 222)
        if (!that.chatId) {
          return
        }
        if (res1.msg == '发送成功' || !res1.msg) {
          let el = that.$refs.footer; // 获取目标元素的引用
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
          }
        }
        if (res1.chatMessage) {
          if (res1.chatMessage.chatId == that.chatId) {
            that.chatMessageList1.push(res1.chatMessage)
            let textDom = document.getElementsByClassName('msgInput')[0]
            textDom.innerHTML = ''
          }
        } else if (res1.chatId) {
          if (res1.chatId == that.chatId) {
            that.chatMessageList1.push(res1)
            let textDom = document.getElementsByClassName('msgInput')[0]
            textDom.innerHTML = ''
          }
        }
        if (res1.chat) {
          let arr = that.chatMsgList
          let small = {}
          let index = 0
          arr.forEach((v, k) => {
            if (v.chatId == res1.chat.chatId) {
              v.unreadCount += 1
              v.latestMessage = res1.chat.latestMessage
              v.latestMessageTime = res1.chat.latestMessageTime
              small = v
              index = k
            }
          })
          arr.splice(index, 1)
          arr.unshift(small)
          that.chatMsgList = arr
        }
      })
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        // 处理回车键按下事件
        this.sendMsg()

      }
    },
    switchMsgStatus(status) {
      this.readStatus = status
      this.getChatMsgList()
    },
    switchMsg(index) {
      this.promoterBy = index - 1
      this.getChatMsgList()
    },
    clearTimout() {
      clearTimeout(this.timer)
      this.timer = null
    },
    sendMsg() {
      let textDom = document.getElementsByClassName('msgInput')[0]
      let text = textDom.innerHTML
      let textStr = textDom.innerText
      if (!text) {
        if (!this.timer) {
          this.$message({
            message: '发送消息不能为空',
            type: 'error'
          })
          this.timer = setTimeout(() => {
            this.clearTimout()
          }, 3000)
        }

        while (textDom.firstChild) {
          textDom.removeChild(textDom.firstChild);
        }
        // console.log(textDom.innerHTML, '<=======')
        return
      }
      let data = {
        chatId: this.chatId,
        userId: this.memberInfo.companyUserId,
        targetUserId: this.memberInfo.memberUserId,
        messageText: text,
        messageType: 1
      }
      let str = JSON.stringify(data)
      this.socket2.send(str)
      this.$nextTick(() => {
        this.scrollBottom()
      });

    },

    getChatMsgs() {
      this.socketConnect()
      this.$get('/api/company/chat/getChatById', {
        chatId: this.chatId
      }).then(res => {
        this.memberInfo = res.data
        this.userResume = res.data.userResume
        this.projectExperienceList = res.data.userResume ? res.data.userResume.projectExperienceList : []
      })
      this.$get('/api/company/chat/getChatMessageList', {
        chatId: this.chatId,
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        this.chatMessageList1 = res.data.list.reverse()
        this.pageNum = 1
        this.chatMessageList2 = []
        setTimeout(res => {
          this.$nextTick(() => {
            let container = this.$el.querySelector("#content");
            // console.log(container);
            container.scrollTop = container.scrollHeight + 100;
          })
        })
      })
    },

    getChatMsg(item) {

      console.log(item);
      if (item) {
        this.chatId = item.chatId;
        this.resName = item.resName
        item.unreadCount = 0
        this.chatItem = item
      }
      console.log(item);
      console.log(this.chatId);
      this.socket2.close()
      this.$cookie.set('chatId', '')
      this.socketConnect()
      this.$get('/api/company/chat/getChatById', {
        chatId: this.chatId
      }).then(res => {
        this.memberInfo = res.data
        this.userResume = res.data.userResume
        this.projectExperienceList = res.data.userResume ? res.data.userResume.projectExperienceList : []
      })
      this.$get('/api/company/chat/getChatMessageList', {
        chatId: this.chatId,
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        this.chatMessageList1 = res.data.list.reverse()
        this.pageNum = 1
        this.chatMessageList2 = []
        setTimeout(res => {
          this.$nextTick(() => {
            let container = this.$el.querySelector("#content");
            // console.log(container);
            container.scrollTop = container.scrollHeight + 100;
          })
        })
      })
    },
    getChatMessageList2() {
      this.$get('/api/company/chat/getChatMessageList', {
        chatId: this.chatId,
        pageNum: this.pageNum,
        pageSize: 10,
      }).then(res => {
        let arr = []
        res.data.list = res.data.list.reverse()
        arr = res.data.list.concat(this.chatMessageList2)
        // console.log(arr)
        this.chatMessageList2 = arr
        this.isLastPage = res.data.isLastPage
      })
    },
    chongzhi() {
      this.resNames = ''
      this.resId = ''
      this.getChatMsgList()
    },
    getChatMsgList(data) {
      this.resId = data?.positionId
      this.resNames = data?.positionTitle
      this.$get('/api/company/chat/getCompanyPcChatList', {
        promoterBy: this.promoterBy == '-1' ? '' : this.promoterBy,
        readStatus: this.readStatus,
        resId: data?.positionId ? data.positionId : ''
      }).then(res => {
        this.chatMsgList = res.data
        if (res.data[0] && !this.chatId) {
          // this.getChatMsg(res.data[0])
        } else if (res.data[0] && this.chatId) {
          // this.getChatMsg()
        }

        this.$nextTick(() => {
          // let appH = document.documentElement.clientHeight
          let appH = document.body.offsetHeight
          let navbarH = document.getElementsByClassName('navbar')[0].clientHeight
          let rightTopH = document.getElementsByClassName('rightTop')[0].clientHeight
          let msgBoxH = document.getElementsByClassName('msgBox')[0].clientHeight
          this.chatPage = appH - 80 - 10
          this.styleObj = {
            height: (appH - navbarH - 20) + 'px'
          }
          this.styleObj2 = {
            height: (appH - 100 - 90 - 10) + 'px'
          }
          this.styleObj3 = {
            height: (appH - 100 - 200 - 10) + 'px'
          }
          this.styleObj4 = {
            height: (appH - navbarH - rightTopH - msgBoxH -30) + 'px'
          }
        })
      })
    },
    getCompanyPositionList() {
      this.$get("/api/company/position/getCompanyPositionListForPC", {
        pageNum: 1,
        pageSize: 1000
      }).then((res) => {
        this.positionList = res.data.list;
      });
    },

    querySearch(queryString, cb) {
      console.log(queryString, 'queryString');
      var restaurants = this.positionList;
      console.log(restaurants);
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        console.log(restaurant);
        return (restaurant.positionTitle.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    seegangwei() {
     
      this.getCompanyPositionInfo(this.memberInfo.positionId,'see')
    },

    seejianli() {
      
      this.getMemberResumeInfo(this.memberInfo.memberUserResumeId,'see')
    },

    cancel(){
      this.showGangwei = false
    },

    getCompanyPositionInfo(id,type){
      console.log(12312312312231);
      console.log(this.memberInfo.memberUserId);
      this.$get("/api/company/position/getPositionApplicationList", {
        memberUserId: this.memberInfo.memberUserId,
      }).then((res) => {
        // console.log(res);
        // this.form = JSON.parse(JSON.stringify(res.data))
        setTimeout(() => {
          for (let i in res.data) {
            this.form[i] = res.data[i] !== null ? res.data[i] : ''
          }
          this.positionApplicationList=res.data;
          console.log(res.data);
          console.log(this.positionApplicationList);
          this.form.positionDescribe = res.data.positionDescribe || ''
          this.form.personnelRequire = res.data.personnelRequire || ''
          this.form.welfareCommission = res.data.welfareCommission || ''
          this.form.positionType = [res.data.positionTypeId, res.data.positionTypeIdSecondary]
          this.form.workPeriod = res.data.workPeriod ? res.data.workPeriod.split(',') : ''
          this.form.positionTag = res.data.positionTag ? res.data.positionTag.split(',') : []
          this.form.positionWorkTypeId = res.data.positionWorkTypeId ? res.data.positionWorkTypeId.split(',') : []
          // this.submitType = type
          this.form.region = []
          this.form.region[0] = res.data.provinceName ? res.data.provinceName.replace('市', '') : ''
          this.form.region[1] = res.data.cityName
          this.form.region[2] = res.data.areaName
          this.coord = res.data.latitude + ',' +res.data.longitude
        }, 200)

        if (res.code == 200 && type == 'see') {
          this.showGangwei = true
        }
      });
    },
   

    getMemberResumeInfo(resumeId,type) {
      console.log(resumeId);
      this.$get('/api/company/resume/getCompanyResumeInfo', {
        resumeId
      }).then(res => {
        if (res.data.resumeCertificateList) {
          res.data.resumeCertificateList.map(item => {
            if (item.certificateImg) {
              item.certificateImg = item.certificateImg.split(',')
            }
          })
        }
        this.resumeForm = res.data
        if (res.code == 200 && type=='see') {
          this.show = true
        }
      })
    },

    //滚动到底部
    scrollBottom() {
      this.$nextTick(() => {
        const dom = this.$refs.chatcontents
        dom.scrollTop = dom.scrollHeight;
      })
    }
  }
};
</script>
<style scoped>
.main {
  padding: 0 10px;
  padding-top: 10px;
}

.search {
  display: flex;
}

.communicate1 {
  display: flex;
  margin-bottom: 10px;
}

.communicate1>div {
  padding: 0px 14px;
  border-radius: 2px 2px 2px 2px;
  height: 28px;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
  margin-right: 16px;
}

.common {
  color: #555555;
}

.active {
  background: #0051AA;
  color: #ffffff;
}

.communicate2 {
  display: flex;
  margin-top: 0px;
}

.left {
  box-sizing: border-box;
  width: 400px;
  /* height: 946px; */
  padding: 16px 20px;
  background: #FFFFFF;
  border-radius: 6px 0px 0px 6px;
}

.left1 {
  margin-top: 10px;
}

.left1>span {
  height: 20px;
  margin-right: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.active1 {
  color: #0051AA;
}

.active2 {
  color: #777777;
}

.system {
  width: 340px;
  height: 67px;
  /* background: #F7F7F7; */
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  cursor: pointer;
  padding: 0 10px 0;
  box-sizing: border-box;
}

.systemLeft {
  position: relative;
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;

}

.header {
  width: 44px;
  height: 44px;
  border-radius: 50%;

}

.subscript {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: #FD403C;
  border-radius: 50%;
  font-weight: 500;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: center;
  position: absolute;
  right: -10px;
  top: -5px;
  z-index: 100;
}

.systemRight {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.chat1Name {
  display: flex;
  align-items: center;
}

.chat1Name .name {
  max-width: 100px;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zhiwei {
  width: 80px;
  font-weight: 500;
  font-size: 12px;
  color: #333333;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat2 {
  width: 150px;
  font-weight: 500;
  font-size: 12px;
  color: #333333;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat3 {
  margin-left: auto;
}


/* .systemRight>div:nth-of-type(1) {
    margin-left: 10px;
  } */



.chat {
  display: flex;
  align-items: center;
}

.chat1 {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.chat1>span:nth-of-type(1) {
  width: 170px;
  height: 22px;
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.chat1>span:nth-of-type(2) {
  width: 100px;
  height: 17px;
  display: inline-block;
  font-weight: 500;
  font-size: 12px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.chat2 {
  /* width: 300px; */
  height: 17px;
  font-weight: normal;
  font-size: 12px;
  color: #777777;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.chat3 {
  /* margin-right: 13px; */
  height: 20px;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.right {
  /* width: 68%; */
  flex: 1;
  margin-left: 10px;
}

.rightTop {
  /* width: 100%; */
  box-sizing: border-box;
  height: 180px;
  padding: 10px 30px;
  background: #FFFFFF;
  border-radius: 0px 6px 6px 0px;
}

.rightTop1 {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.rightTop1>div {
  display: flex;
  align-items: center;
}

.rightTop1Item1 {
  display: flex;
  align-items: center;
}

.rightTop1Item1Span {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-right: 44px;
}

.rightTop1Item1>img {
  width: 10px;
  height: 10px;
}

.rightTop1Item2 {
  height: 20px;
  font-family: PingFangSC-Regular, PingFangSC-Regular;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.rightTop1Item2>span {
  margin-right: 10px;
  margin-left: 10px;
}

.rightTop1Item3>div {
  width: 90px;
  height: 34px;
  margin-left: 20px;
  background: #0051AA;
  border-radius: 2px 2px 2px 2px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 34px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.rightTop2 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* .rightTop2Item1{
  min-width: 300px;
} */

.rightTop2Item1 {
  height: 88px;
  overflow-y: auto;
  padding-right: 6px;
}

.rightTop2Item1::-webkit-scrollbar {
  display: none;
}

.rightTop2Item1::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom right, #4d7fff 0%, #1a56ff 100%);
  border-radius: 5px;
}

.rightTop2Item1::-webkit-scrollbar-track {
  background-color: #ddd;
  border: 1px solid #ccc;
}

.rightTop2Item1::-webkit-scrollbar-button {
  background-color: #4d7fff;
  border-radius: 5px;
}

.rightTop2Item1::-webkit-scrollbar-button:hover {
  background-color: #999999;
}

.rightTop2Item2 {
  /* width: 350px; */
}

.rightTop2Item2>div {
  height: 20px;
  margin-top: 10px;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.rightDown {
  margin-top: 10px;
}

.content {
  width: 100%;
  /* height: 500px; */
  /* padding-top: 50px; */
  /* 指定元素的高度 */
  background-color: #FFFFFF;
  overflow-y: scroll;
  /* overflow-x: hidden; */
  /* 当内容超过高度时显示滚动条 */
}

.chatContent {
  width: 100%;
  /* padding: 0 20px; */
  box-sizing: border-box;
}

.chatTime {
  width: 100%;
  margin-top: 20px;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.chatOtherSide {
  max-width: 90%;
  display: flex;
  margin-top: 20px;
  padding-left: 20px;
}

.chatOtherSide>img {
  margin-top: 4px;
  width: 42px;
  height: 42px;
  margin-right: 10px;
}

.chatOtherText {
  margin-top: 4px;
  max-width: 60%;
  height: 100%;
  /* height: 30px; */
  background: #EAF2FF;
  border-radius: 6px 6px 6px 6px;
  font-weight: 400;
  text-align: left;
  font-size: 14px;
  color: #000000;
  padding: 15px 20px;
}

.chatOwn {
  padding-right: 20px;
  height: 100%;
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
}

.chatText {
  margin-top: 4px;
  max-width: 60%;
  height: 100%;
  /* height: 30px; */
  background: #EAF2FF;
  border-radius: 6px 6px 6px 6px;
  font-weight: 400;
  text-align: left;
  font-size: 14px;
  color: #000000;
  padding: 15px 20px;
}

.touxiang {
  width: 42px;
  height: 42px;
}

.chatImg {
  width: 100px;
  height: 100px;
  border-radius: 6px;

}

.chatImg>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.chatOwn>img {
  width: 42px;
  height: 42px;
  margin-left: 10px;
}

.msgBox {
  height: 130px;
  border-top: 1px solid #EBEBEB;
  background-color: #FFFFFF;
  padding: 10px;
  position: relative;
}

.msgInput {
  /* width: 900px; */
  font-size: 14px;
  border: none;
  /* height: 200px; */
  outline: none;
  height: 130px;

}

.msgInput:empty::before {
  content: attr(placeholder);
  color: grey;
}


.sendMsg {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 62px;
  height: 30px;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.systemList {
  height: 100%;
  overflow-y: scroll;
}

.systemList::-webkit-scrollbar {
  /* display: none; */
}

.content::-webkit-scrollbar {
  /* display: none; */

}

.itemitems {
  display: flex;
}

.itemitemText {
  width: 70px;
  margin-right: 10px;
  text-align: left;
}

.inline-input {
  width: 292px;
  margin-right: 10px;
}

.systemBox {
  width: 100%;
  display: flex;
}

.Rtimeline .el-timeline-item {
  padding-bottom: 3px !important;
}

.systemActive {
  background: linear-gradient(97deg, #C4DAFF 0%, #FFFFFF 100%);
}
</style>

<style>
.Rtimeline .el-timeline-item .el-timeline-item__wrapper {
  padding-left: 20px;
}

.Rtimeline .el-timeline-item .el-timeline-item__wrapper .el-timeline-item__content {
  font-size: 14px;
  color: #555555;
}

.Rtimeline .el-timeline-item .el-timeline-item__node--normal {
  width: 5px;
  height: 5px;
  left: 2.5px;
  top: 5px;
}

.Rtimeline .el-timeline-item .el-timeline-item__tail {
  top: 10px;
}

.experience_class {
  width: 120px;
}
</style>

<style>
.scroll-bar-overlay {
  overflow-y: overlay !important;
}

.dom-scrollbar-show::-webkit-scrollbar {
  width: 8px !important;
}

.dom-scrollbar-hide::-webkit-scrollbar {
  width: 0 !important;
}
</style>